import { Box as MuiBox } from '@mui/material'
import { styled } from '@mui/system'

export const ContentFilters = styled(MuiBox)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '24px',
  height: '32px'
}))

export const MainContent = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  gap: theme.spacing(4),
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  }
}))

export const TableContent = styled(MuiBox)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  gap: theme.spacing(1),
  overflow: 'hidden',
  minWidth: 0
}))
